import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

interface FreelancerRouteProps {
  children: React.ReactNode;
}

const FreelancerRoute: React.FC<FreelancerRouteProps> = ({ children }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [isFreelancer, setIsFreelancer] = useState(false);
  const [isApproved, setIsApproved] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const checkUser = async () => {
      try {
        const userData = localStorage.getItem('user');
        if (userData) {
          const user = JSON.parse(userData);
          setIsFreelancer(user.role === 'freelancer');
          setIsApproved(user.is_approved);
        }
      } catch (error) {
        console.error('Error checking user:', error);
      } finally {
        setIsLoading(false);
      }
    };

    checkUser();
  }, []);

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="loading-spinner mx-auto mb-4"></div>
          <p className="text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  const token = localStorage.getItem('token');
  
  if (!token) {
    return <Navigate to="/signin" state={{ from: location }} replace />;
  }

  if (!isFreelancer) {
    return <Navigate to="/dashboard" replace />;
  }

  if (!isApproved) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="warning-message max-w-md">
            <h2 className="text-xl font-bold text-yellow-800 mb-4">Approval Required</h2>
            <p className="text-yellow-700 mb-6">
              Your freelancer account needs to be approved before you can access this feature.
              Please contact an administrator or wait for approval.
            </p>
            <a href="/dashboard" className="btn btn-primary">
              Go to Dashboard
            </a>
          </div>
        </div>
      </div>
    );
  }

  return <>{children}</>;
};

export default FreelancerRoute;